class GoldenKidsHeader extends HTMLElement {
  #resizeObserver = new ResizeObserver(() => this.#updateHeaderHeights());

  connectedCallback() {
    this.#resizeObserver.observe(this);
    this.#syncSearchPlaceholder();
    this.#updateHeaderHeights();
  }

  disconnectedCallback() {
    this.#resizeObserver.disconnect();
  }

  #syncSearchPlaceholder() {
    const placeholder = this.dataset.searchPlaceholder;
    const searchInput = document.querySelector('#search-modal .search-input');

    if (placeholder && searchInput instanceof HTMLInputElement) {
      searchInput.placeholder = placeholder;
    }
  }

  #updateHeaderHeights() {
    const headerHeight = Math.round(this.getBoundingClientRect().height);
    const headerGroup = document.querySelector('#header-group');
    const headerGroupHeight = headerGroup instanceof HTMLElement ? Math.round(headerGroup.getBoundingClientRect().height) : headerHeight;

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
  }
}

(() => {
  if (window.__gkCollectionNavigationBound) return;
  window.__gkCollectionNavigationBound = true;

  const navigationLoadingKey = 'gk-collection-navigation-loading';
  const getCollectionPath = (url) => `${url.pathname}${url.search}`;

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.defaultPrevented ||
        (event.button !== undefined && event.button !== 0) ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      let destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch {
        return;
      }

      if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/collections/')) return;

      const currentPath = getCollectionPath(new URL(window.location.href));
      const destinationPath = getCollectionPath(destination);
      if (currentPath === destinationPath) return;

      try {
        window.sessionStorage.setItem(navigationLoadingKey, destinationPath);
      } catch {
        // The results-area state below still gives feedback if session storage is unavailable.
      }

      const results = document.querySelector('.collection-page-results');
      if (results) {
        results.setAttribute('data-gk-filter-loading', 'true');
        results.removeAttribute('data-gk-filter-ready');
      }
    },
    true
  );
})();

if (!customElements.get('golden-kids-header')) {
  customElements.define('golden-kids-header', GoldenKidsHeader);
}
